import React, { useEffect, useRef, useState } from "react";
import {
  MAIN_URL,
  getApiCall,
  getApiCallForVideo,
  postApiCall,
  postFormApiCall,
} from "../../utils/api";
import MaterialTable from "material-table";
import tableIcons from "../component/MaterialIcon";
import { ThemeProvider, createTheme } from "@mui/material";
import { Delete, Edit } from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Modal } from "@material-ui/core";
import {
  CircleSpinnerOverlay,
  FerrisWheelSpinner,
} from "react-spinner-overlay";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const RoadSafetyClub = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);

  const [data, setData] = useState([]);
  const [editGroupid, setEditGroupId] = useState("");

  const [loading, setLoading] = useState(false);

  const [schoolList, setSchoolList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [schoolName, setSchoolName] = useState("");
  const [groupName, setGroupName] = useState("");
  const [topic, setTopic] = useState("");
  const [fileEnglish, setFileEnglish] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const schools = await getApiCall("school/get-all-active");
    setSchoolList(schools.data);

    const res = await getApiCall("get-all-group-data");
    setData(res.data);

    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  const handleFileUploadEn = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileEnglish(file);
    } else {
      alert("Something went wrong");
    }
  };

  const fileInputRefEnglish = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("id", editGroupid);
    formData.append("group_id", groupName);
    formData.append("topic", topic);
    formData.append("file", fileEnglish);

    let res = {};
    if (editGroupid === "") {
      res = await postFormApiCall("raod-safety/add", formData);
    } else {
      res = await postFormApiCall("admin-update-group-task", formData);
    }
    setLoading(false);
    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });

    setEditGroupId("");

    if (fileInputRefEnglish.current) {
      fileInputRefEnglish.current.value = "";
    }

    setTopic("");
    setGroupName("");
    setSchoolName("");
    setFileEnglish(null);
    setLoading(false);
    fetchData();
  };

  const onSchoolChange = async (val) => {
    console.log(val);

    setLoading(true);
    const groupData = await postApiCall("get-group-data-by-school-id-admin", {
      school_id: val,
    });
    setGroupList(groupData.data);
    setLoading(false);
  };

  const columns = [
    {
      title: "Sl. no",
      field: "serial",
      cellStyle: {
        width: "5%",
      },
    },
    {
      title: "Name",
      field: "name",
    },
    { title: "School", field: "school_name" },
    { title: "Group ID", field: "groupid" },
    { title: "Student Involved", field: "student_names" },
    { title: "Task Title", field: "task_title" },
    {
      title: "Files",
      field: "file",
      render: (rowData) => {
        return (
          <>
            {rowData.task_file_path && (
              <a
                href={MAIN_URL + rowData.task_file_path}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginRight: "10px" }}
              >
                📄 View
              </a>
            )}
          </>
        );
      },
    },
  ];

  const handleEdit = async (rowData) => {
    setEditGroupId(rowData.id);

    setSchoolName(rowData.school_admin_id);
    onSchoolChange(rowData.school_admin_id);
    setGroupName(rowData.id);
    setTopic(rowData.task_title);

    inputRef.current.focus();
    const input = document.getElementById("boardInput");
    input.focus();
  };

  const handleDelete = async (rowData) => {
    new Swal({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("readings/delete", { id: rowData.id });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Road Safety Club</h4>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Road Safety Club</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">
                      Edit Road Safety Club
                    </h3>
                  </div>
                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              Edit School
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setSchoolName(e.target.value);
                                onSchoolChange(e.target.value);
                              }}
                              required
                              value={schoolName}
                              name="school_id"
                              disabled
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {schoolList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              Edit Group
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setGroupName(e.target.value);
                              }}
                              required
                              value={groupName}
                              name="group_id"
                              disabled
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {groupList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <h5>Add Information</h5>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              Edit Topic
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setTopic(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={topic}
                              name="title"
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12"></div>

                        <div className="col-md-6 col-sm-12">
                          <div class="form-group">
                            <label htmlFor="classInput">
                              Edit File
                            </label>
                            <div class="input-group">
                              <input
                                type="file"
                                // accept="image/*"
                                ref={fileInputRefEnglish}
                                onChange={(e) => handleFileUploadEn(e)}
                                // required={editGroupid === "" ? true : false}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">
                        Update
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Road Safety Club"
                      columns={columns}
                      data={data}
                      onRowClick={(evt, selectedRow) =>
                        setSelectedRow(selectedRow.tableData.id)
                      }
                      options={{
                        exportButton: true,
                        exportCsv: (columns, data) => {
                          // Extract column titles
                          const columnTitles = columns.map((col) => col.title);

                          // Build CSV rows
                          const csvData = data.map(
                            (row) => columns.map((col) => row[col.field] ?? "") // handle undefined fields
                          );

                          // Combine into a full CSV
                          const csv = Papa.unparse({
                            fields: columnTitles,
                            data: csvData,
                          });

                          // Create and trigger file download
                          const blob = new Blob([csv], {
                            type: "text/csv;charset=utf-8;",
                          });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement("a");
                          link.href = url;
                          link.setAttribute(
                            "download",
                            "reading-materials.csv"
                          );
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        },
                        exportPdf: (columns, data) => {
                          const doc = new jsPDF();
                          const tableColumnTitles = columns.map(
                            (col) => col.title
                          );
                          const tableRows = data.map((row) =>
                            columns.map((col) => row[col.field] ?? "")
                          );

                          autoTable(doc, {
                            head: [tableColumnTitles],
                            body: tableRows,
                            styles: { fontSize: 8 },
                            headStyles: { fillColor: [0, 123, 255] },
                          });

                          doc.save("reading-materials.pdf");
                        },
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor:
                            selectedRow === rowData.tableData.id
                              ? "#d3d4d1"
                              : index % 2 !== 0
                              ? "#EEE"
                              : "#FFF",
                        }),
                      }}
                      actions={[
                        {
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Edit />
                            </span>
                          ),
                          tooltip: "Edit",
                          onClick: (event, rowData) => handleEdit(rowData),
                        },
                        // (rowData) => ({
                        //   icon: () => (
                        //     <span style={{ color: "#5656ce" }}>
                        //       <Delete />
                        //     </span>
                        //   ),
                        //   tooltip: "Delete",
                        //   onClick: (event, rowData) => handleDelete(rowData),
                        // }),
                      ]}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
    </div>
  );
};

export default RoadSafetyClub;
